/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { globalSettingsOptimizePermissionSchemeRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsOptimizePermissionSchemeRoute.tsx';
import { optimizePermissionSchemePageEntrypoint } from './ui/spa/admin-pages/performance/optimize-permission-scheme-page/optimize-permission-scheme-page-entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsOptimizePermissionSchemeRouteEntry: Route = createEntry(
	globalSettingsOptimizePermissionSchemeRoute,
	() => ({
		group: 'global-settings',

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation],
		entryPoint: () => {
			return optimizePermissionSchemePageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
			enabled: true,
		},
	}),
);
